import {
    IDX_RPT_EQUIPMENT_REPORT,
    IDX_RPT_EQUIPMENT_REPORT_SUCCESS,
    IDX_RPT_EQUIPMENT_REPORT_ERROR,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_EQP,
    IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR,
    IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR,
    IDX_RPT_EQUIPMENT_SERVICE_LIST,
    IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS,
    IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR
} from "../../actions";

const INIT_STATE = {
    loading: false,
    reportlist: {
        loading: false,
        data: []
    },
    hospitallist: {
        loading: false,
        data: []
    },
    detailequipment: {
        loading: false,
        data: []
    },
    nolocation: {
        loading: false,
        data: []
    },
    operationstatus: {
        loading: false,
        data: []
    },
    requiredquantity: {
        loading: false,
        data: []
    },
    others: {
        loading: false,
        data: []
    },
    justification: {
        loading: false,
        data: []
    },
    evaluationform: {
        loading: false,
        data: []
    },
    reqeqphospitalservice: {
        loading: false,
        data: []
    },
    service: {
        loading: false,
        data: []
    },
    technologytype: {
        loading: false,
        data: []
    },
    reqeqpbytechnologytype: {
        loading: false,
        data: []
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            hospital_det_eqp: '',
            hospital_det_eqp_wo_location: '',
            hospital_det_eqp_wo_op_stat: '',
            hospital_det_eqp_wo_req_qty: '',
            hospital_det_eqp_others: '',
            hospital_det_eqp_just: '',
            hospital_eval: '',
            hospital_req: '',
            service_req: '',
            technology_req: ''
        },
        value: {
            hospital_det_eqp: '',
            hospital_det_eqp_wo_location: '',
            hospital_det_eqp_wo_op_stat: '',
            hospital_det_eqp_wo_req_qty: '',
            hospital_det_eqp_others: '',
            hospital_det_eqp_just: '',
            hospital_eval: '',
            hospital_req: '',
            service_req: '',
            technology_req: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case IDX_RPT_EQUIPMENT_REPORT:
            return {
                ...state,
                loading: true,
                reportlist: {
                    ...state.reportlist
                }
            }
        case IDX_RPT_EQUIPMENT_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                reportlist: {
                    ...state.reportlist,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_HOSPITAL_LIST:
            return {
                ...state,
                loading: true,
                hospitallist: {
                    ...state.hospitallist
                }
            }
        case IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                hospitallist: {
                    ...state.hospitallist,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DETAIL_EQP:
            return {
                ...state,
                loading: true,
                detailequipment: {
                    ...state.detailequipment
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS:
            return {
                ...state,
                loading: false,
                detailequipment: {
                    ...state.detailequipment,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION:
            return {
                ...state,
                loading: true,
                nolocation: {
                    ...state.nolocation
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                nolocation: {
                    ...state.nolocation,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS:
            return {
                ...state,
                loading: true,
                operationstatus: {
                    ...state.operationstatus
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                operationstatus: {
                    ...state.operationstatus,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY:
            return {
                ...state,
                loading: true,
                requiredquantity: {
                    ...state.requiredquantity
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS:
            return {
                ...state,
                loading: false,
                requiredquantity: {
                    ...state.requiredquantity,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OTHERS:
            return {
                ...state,
                loading: true,
                others: {
                    ...state.others
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS:
            return {
                ...state,
                loading: false,
                others: {
                    ...state.others,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION:
            return {
                ...state,
                loading: true,
                justification: {
                    ...state.justification
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                justification: {
                    ...state.justification,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_EVALUATION_FORM:
            return {
                ...state,
                loading: true,
                evaluationform: {
                    ...state.evaluationform
                }
            }
        case IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                evaluationform: {
                    ...state.evaluationform,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case IDX_RPT_REQ_EQP_HOSPITAL_SERVICE:
            return {
                ...state,
                loading: true,
                reqeqphospitalservice: {
                    ...state.reqeqphospitalservice
                }
            }
        case IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS:
            return {
                ...state,
                loading: false,
                reqeqphospitalservice: {
                    ...state.reqeqphospitalservice,
                    ...action.payload
                }
            }
        case IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case IDX_RPT_EQUIPMENT_SERVICE_LIST:
            return {
                ...state,
                loading: true,
                service: {
                    ...state.service
                }
            }
        case IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                service: {
                    ...state.service,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE:
            return {
                ...state,
                loading: true,
                technologytype: {
                    ...state.technologytype
                }
            }
        case IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                technologytype: {
                    ...state.technologytype,
                    ...action.payload
                }
            }
        case IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE:
            return {
                ...state,
                loading: true,
                reqeqpbytechnologytype: {
                    ...state.reqeqpbytechnologytype
                }
            }
        case IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                reqeqpbytechnologytype: {
                    ...state.reqeqpbytechnologytype,
                    ...action.payload
                }
            }
        case IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};


